import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // UI
        this.$container = this.$('container')[0]
        this.$prevButton = this.$('prev')[0]
        this.$nextButton = this.$('next')[0]

        // Data
        this.length = this.$('item').length

        const args = {
            speed: 700,
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 1,
            navigation: {
                prevEl: this.$prevButton,
                nextEl: this.$nextButton,
            }
        }

        if( this.length > 1) {
            this.carousel = new Swiper(this.$container, args)
        }

        // if(this.slideCount >1) {
        //     this.carousel = new Swiper(this.el, {
        //         slidesPerView: 1,
        //         spaceBetween: 20,
        //         loop: true,
        //         loopedSlides: this.slideCount,
        //         grabCursor: true,
        //         threshold: 3,
        //         init: false
        //     })

        //     this.carousel.init()
        // }
    }

    destroy() {
        super.destroy()
        this.carousel.destroy(true,true)
    }
}
